import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  padding-right: 250px;

  ${Media.lg`
    padding-right: initial;
  `}
`;

export const Information = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: 400;
  cursor: default;

  pre {
    white-space: pre-line;
  }
`;

export const Item = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 30px;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: -20px;
    left: -20px;
    bottom: 0;
    content: '';
  }

  &:last-of-type:after {
    display: none;
  }

  ${Media.xlg`
    flex-wrap: wrap;
  `}
`;

export const Column = styled.div`
  display: block;
  width: 50%;

  &:first-of-type {
    padding-right: 15px;

    ${Media.xlg`
      padding-right: 0;
    `}
  }

  &:last-of-type {
    padding-left: 15px;
    ${Media.xlg`
      padding-left: 0;
    `}
  }

  ${Media.xlg`
    width: 100%;
  `}
`;

export const Title = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 30px;
  color: ${(props) => props.theme.color};
  font-size: 25px;
  font-weight: 700;
  cursor: default;
`;

export const Param = styled.div`
  display: block;
  width: 100%;
  color: ${(props) => props.theme.color};
  font-size: 21px;
  font-weight: 500;
  cursor: default;
`;

export const Details = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 30px;
  color: ${(props) => props.theme.color};
  font-size: 16px;
  font-weight: 400;
  cursor: default;

  pre {
    white-space: pre-line;
  }
`;

export const Attributes = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 30px;
`;

export const AttributesTitle = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 21px;
  font-weight: 700;
  cursor: default;
`;

export const AttributesContent = styled.div`
  display: block;
  width: 100%;
  padding: 20px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.border};
  font-size: 18px;
  font-weight: 400;
  cursor: default;

  pre {
    white-space: pre;
  }
`;

export const Body = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 30px;
`;

export const BodyTitle = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 21px;
  font-weight: 700;
  cursor: default;
`;

export const BodyContent = styled.div`
  display: block;
  width: 100%;
  padding: 20px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.border};
  font-size: 18px;
  font-weight: 400;
  cursor: default;

  pre {
    white-space: pre;
  }
`;

export const Response = styled.div`
  display: block;
  width: 100%;
`;

export const ResponseTitle = styled.div`
  display: block;
  width: 100%;
  padding: 10px 20px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.border};
  font-size: 17px;
  font-weight: 400;
  cursor: default;
`;

export const ResponseContent = styled.div`
  display: block;
  width: 100%;
  padding: 20px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.border};
  font-size: 18px;
  font-weight: 400;
  cursor: default;

  pre {
    white-space: pre;
  }
`;
